@if (isAuthRoute()) {
  <router-outlet />
} @else {
  <app-layout></app-layout>
}
